export function unavailableRoomResourceReason({ label, resource, locallyActive = false, fallbackReason = null } = {}) {
  if (locallyActive) {
    return null;
  }

  if (resource?.limit === 0) {
    return `${label} is disabled for this Verse`;
  }

  if (
    typeof resource?.limit === "number" &&
    (resource.exhausted || resource.available === 0 || resource.used >= resource.limit)
  ) {
    return `${label} limit reached: ${resource.limit} active`;
  }

  return fallbackReason;
}
